import { render, staticRenderFns } from "./setUser.vue?vue&type=template&id=4c119554&scoped=true"
import script from "./setUser.vue?vue&type=script&lang=js"
export * from "./setUser.vue?vue&type=script&lang=js"
import style0 from "./setUser.vue?vue&type=style&index=0&id=4c119554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c119554",
  null
  
)

export default component.exports